import css from 'styled-jsx/css';

const styles = css.global`#carros-eletricos-para-voce {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-color: #F0F0F0;
}

#carros-eletricos-para-voce .ctn {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-top: 24px;
}

.carros-eletricos-para-voce-super-title {
  color: #222222;
  font-family: "SantanderHeadline";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin: 0;
}

.carros-eletricos-para-voce-super-title b {
  font-weight: 900 !important;
}

.carros-eletricos-para-voce-img {
  width: 243px;
  height: 178px;
  box-shadow: -43px -31px 0px 0px #cc0000;
  margin: 58px auto 0;
  object-fit: cover;
  border-radius: 4px;
  display: flex;
}

.carros-eletricos-para-voce-texts {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.carros-eletricos-para-voce-title {
  font-family: 'SantanderHeadline';
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  color: #cc0000;
  margin: 0;
  margin-top: 24px;
  width: 100%;
}

.carros-eletricos-para-voce-title b {
  font-weight: 700;
  color: #cc0000;
}

.carros-eletricos-para-voce-description {
  font-family: 'SantanderHeadline';
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  width: 100%;
  color: #222222;
  margin-bottom: 32px;
  margin-top: 16px;
}

.carros-eletricos-para-voce-description b {
  color: #444;
  font-weight: 900!important;
}

.carros-eletricos-para-voce-btn {
  width: 232px;
  /* margin-bottom: 40px; */
}

.carros-eletricos-circles-pra-vc-mb {
  position: absolute;
  z-index: 0;
  left: 0;
  top: 25px;
  background-image: url('assets/carros-eletricos/circles-pra-vc-mb.png');
  width: 75px;
  height: 32px;
  background-repeat: no-repeat;
}

.carros-eletricos-circles-pra-vc-ds {
  display: none;
  z-index: 0;
}

.carros-eletricos-disclaimer {
  font-family: "SantanderText";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  color: #222;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.carros-eletricos-disclaimer a {
  color: #cc0000;
  text-decoration: underline;
}

@media (min-width: 992px) {
  #carros-eletricos-para-voce {
    padding-top: 32px;
    padding-bottom: 45px;
    background-color: #FBFBFB;
  }

  #carros-eletricos-para-voce .ctn {
    padding-top: 0;
  }

  .carros-eletricos-para-voce-contain {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 94px;
  }

  .carros-eletricos-para-voce-super-title {
    font-size: 32px;
    line-height: 48px;
  }

  .carros-eletricos-para-voce-img {
    width: 551px;
    height: 366px;
    margin-right: 0px;
    box-shadow: -116px -40px 0px 0px #cc0000;
    border-radius: 4px;
    margin-top: 80px;
  }

  .carros-eletricos-para-voce-texts {
    width: 471px;
    align-items: flex-start;
  }

  .carros-eletricos-para-voce-title {
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    margin: 0;
  }


  .carros-eletricos-para-voce-description {
    color: #444;
    font-size: 18px;
    line-height: 28px;
    text-align: left;
    width: 100%;
    margin-top: 24px;
    margin-bottom: 32px;
  }

  .carros-eletricos-para-voce-description b {
    font-weight: 900 !important;
  }

  .carros-eletricos-para-voce-btn {
    width: 236px;
    margin-bottom: 0;
  }

  .carros-eletricos-circles-pra-vc-mb {
    display: none;
  }

  .carros-eletricos-circles-pra-vc-ds {
    position: absolute;
    display: flex;
    z-index: 0;
    top: -10px;
    left: -170px;
    background-image: url('assets/carros-eletricos/circles-pra-vc-ds.png'), url('assets/carros-eletricos/circles-pra-vc-ds.webp');
    width: 159px;
    height: 99px;
    background-repeat: no-repeat;
  }

  .carros-eletricos-disclaimer {
    width: 100%;
    text-align: left;
    margin-bottom: 0;
  }
}
`;

export default styles;